import {
  fcheck_null_undefine_replace_empty,
  fAlertToast,
} from "../../Utility/Utilitys";

import { vRdxUserInfo } from "../../Redux/roStore";
import { common_LocationSearch_GETROW } from "../../Server/ApiV2";

export const sWebStockReportData = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
];
export const sWebStockReportArr = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
  { Uid: "From", Value: "From" },
  { Uid: "To", Value: "To" },
  { Uid: "Between", Value: "Between" },
];
export const sWebBetweenReportArr = [{ Uid: "Between", Value: "Btwn" }];

export const HeadObjectInit = {
  sDate: sWebBetweenReportArr[0].Uid,
  sFromDate: new Date(),
  sToDate: new Date(),
  sReportType: "PENDING",
  sLocation: "Is",
  sLocationArr: [],
  sLocationPrnt: "",
  sLocationCode: "",
  sLocationName: "",
};

export const GetLocation = async (setLocation) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  //v_AnyData,v_Cd,v_Name,v_Distri,v_UserCd
  var vLocobj = {
    v_AnyData: "",
    v_Cd: "",
    v_Name: "",
    v_Distri: "N",
    v_UserCd: vRdxUserInfoObj.UserID,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vLocobj);
  const vLocation = await common_LocationSearch_GETROW(FinalObj);
  if (vLocation?.status === 200) {
    setLocation(vLocation?.data?.ResultSet);
  }
};

export const fValidationHead_Client = (HeadObject) => {
  let iRes = true;

  if (
    HeadObject.sFromDate === "" ||
    HeadObject.sFromDate === null ||
    HeadObject.sFromDate === undefined ||
    HeadObject.sFromDate === "Invalid Date" ||
    HeadObject.sToDate === "" ||
    HeadObject.sToDate === null ||
    HeadObject.sToDate === undefined ||
    HeadObject.sToDate === "Invalid Date"
  ) {
    fAlertToast("FAILED", "Date should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sReportType === "" &&
    HeadObject.sReportType === null &&
    HeadObject.sReportType === undefined
  ) {
    fAlertToast("FAILED", "Purchase Type should not be empty");

    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sLocation.toUpperCase() === "IS" &&
    HeadObject.sLocationPrnt === ""
  ) {
    fAlertToast("FAILED", "Location should not be empty");

    iRes = false;
    return iRes;
  }

  return iRes;
};
